import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  CustomInput,
  Form,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Label,
  FormGroup,
} from "reactstrap";
import { Redirect } from "react-router";
import {
  addQuantity,
  addToCart,
  removeFromCart,
  subQuantity,
} from "../../redux/actions/orderqrcart.actions";
import paymentsuccess from "../../assets/imgs/new/paymentSuccess.png";
import QRCode from "qrcode.react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateDeliveryAddress,
  updateUserInfo,
} from "../../redux/actions/auth.action";
import firebase from "../../redux/firebase";
import { createOrder } from "../../redux/actions/orderqrcode.action";
import { toast } from "react-toastify";
import { Elements, ElementsConsumer } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { PUBLIC_KEY, BASE_DOMAIN } from "../../constants";
import axios from "axios";
import { customAlert } from "../../redux/actions/alertActions";
let stripePromise = loadStripe(PUBLIC_KEY);
function Checkout(props) {
  let total = 0;
  const { id, delivery_address, firstname, lastname, email, user } =
    useSelector((state) => state.authUser);
  console.log("user", user);
  let loginUser = useSelector((state) => state.authUser);
  console.log("loginUser", loginUser);
  const { delivery_loading } = useSelector((state) => state.auth);
  const { memoirs } = useSelector((state) => state.memoir);
  const { loading } = useSelector((state) => state.orderQrCode);
  const { qr_list } = useSelector((state) => state.orderQrCart);
  const dispatch = useDispatch();

  const qrCodesBGColors = ["#DBC3A6", "#FBBB00", "#FF4B55"];
  const ls = JSON.parse(localStorage.getItem("QR_Data"));
  let { isOpen, checkOutToggle } = props;
  const [modals, setModals] = useState({
    confirmation: false,
  });
  const [redirect, setRedirect] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  const [chargeId, setChargeId] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [payComplete, setPayComplete] = useState(false);

  // delivery address
  const [country, setCountry] = useState(loginUser.country);
  const [firstName, setFirstName] = useState(
    loginUser ? loginUser.first_name : "N/A"
  );
  const [lastName, setLastName] = useState(
    loginUser ? loginUser.last_name : "N/A"
  );
  const [address1, setAddress1] = useState(
    loginUser ? loginUser.address1 : "N/A"
  );
  const [address2, setAddress2] = useState(loginUser && loginUser.address2);
  const [town, setCity] = useState(loginUser && loginUser.town);
  const [zipCode, setZipCode] = useState(loginUser && loginUser.zip_code);
  const toggleModal = async (name) => {
    let newModal = JSON.parse(JSON.stringify(modals));
    for (let modal of Object.keys(newModal)) {
      if (modal != name) newModal[modal] = false;
    }
    newModal[name] = !newModal[name];
    setModals(newModal);
    if (name == "confirmation" && newModal[name] == false) {
      await setRedirect(true);
    }
  };
  const getMemoirName = (id) => {
    if (id != undefined) {
      let obj = memoirs && memoirs.find((mem) => mem.id == id);
      if (obj != null) {
        return obj.memoir_title;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  if (redirect) {
    console.log("in redirect ");
    return <Redirect to="/dashboard/manage-account" />;
  }
  return (
    <>
      <Modal isOpen={isOpen} size="xl">
        <ModalBody className="p-0">
          <Row noGutters>
            <Col xl="7">
              <div className="modal-content-wrapper ">
                <div className="d-flex align-items-center">
                  <small>Shipping & Payment Information</small>
                  <span className="text-muted ">
                    <i className="mx-3 fa fa-long-arrow-right"></i>
                    <small>Check & Place Order</small>
                  </span>
                </div>
                <h4 className="font-weight-bold">
                  Shipping & Payment Information
                </h4>
                <div className="mt-4 d-flex align-items-center">
                  <i className="fa fa-home mr-3"></i>
                  Enter Delivery Address
                </div>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    console.log("here");
                    let obj = {
                      country: country,
                      first_name: firstName,
                      last_name: lastName,
                      address1: address1,
                      address2: address2,
                      town: town,
                      zip_code: zipCode,
                    };
                    // dispatch(updateDeliveryAddress(id, obj));
                    dispatch(updateUserInfo(id, obj));
                  }}
                >
                  <div className="mt-3">
                    <Row>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">Country</label>
                          <input
                            className="form-control custom-form-control white"
                            defaultValue={country}
                            // onChange={(e) => setCountry(e.target.value)}
                            required
                            type="text"
                            readOnly
                          ></input>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">First Name</label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="First Name"
                            defaultValue={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">Last Name</label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="Last Name"
                            defaultValue={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">
                            Address Line 1
                          </label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="Address Line 1"
                            defaultValue={address1}
                            onChange={(e) => setAddress1(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">
                            Address Line 2
                          </label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="Address Line 2"
                            defaultValue={address2}
                            onChange={(e) => setAddress2(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                      <Col md="6">
                        <div className="form-group">
                          <label className="font-weight-bold">City</label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="City"
                            defaultValue={town}
                            onChange={(e) => setCity(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                      <Col md="4">
                        <div className="form-group">
                          <label className="font-weight-bold">
                            Zip / Post Code
                          </label>
                          <input
                            className="form-control custom-form-control white"
                            type="text"
                            placeholder="Zip / Post Code"
                            defaultValue={zipCode}
                            onChange={(e) => setZipCode(e.target.value)}
                            required
                          ></input>
                        </div>
                      </Col>
                    </Row>
                    <Button
                      className="mt-3 btn-outline dashboard-btn"
                      type="submit"
                      disabled={delivery_loading}
                    >
                      {delivery_loading ? (
                        <Spinner size="sm" />
                      ) : (
                        "Save Address"
                      )}
                    </Button>
                  </div>
                </Form>
                <div className="mt-4 d-flex align-items-center">
                  <i className="fa fa-credit-card mr-3"></i>
                  Choose Payment Method
                </div>
                <div className="mt-3">
                  <Elements stripe={stripePromise}>
                    <ElementsConsumer>
                      {({ elements, stripe }) => (
                        <Form
                          onSubmit={async (e) => {
                            e.preventDefault();
                            await setPayLoading(true);
                            const cardElement = await elements.getElement(
                              CardNumberElement
                            );
                            const cardElement2 = await elements.getElement(
                              CardExpiryElement
                            );
                            const cardElement3 = await elements.getElement(
                              CardCvcElement
                            );

                            const { error, paymentMethod } =
                              await stripe.createPaymentMethod({
                                type: "card",
                                card: cardElement,
                                card: cardElement2,
                                card: cardElement3,
                              });
                            if (error) {
                              await setPayLoading(false);
                              dispatch(
                                customAlert(true, "Card Details not Added")
                              );
                              setTimeout(() => {
                                dispatch(customAlert(false, ""));
                              }, 1500);
                              // alert(
                              // 	'Card Details not Added'
                              // );
                            } else {
                              // console.log("[payment Method]", paymentMethod)
                              const result = await stripe.createToken(
                                cardElement
                              );
                              // console.log("result", result)
                              if (result.error) {
                                dispatch(
                                  customAlert(true, result.error.message)
                                );
                                setTimeout(() => {
                                  dispatch(customAlert(false, ""));
                                }, 1500);
                                // alert(
                                // 	result.error
                                // 		.message
                                // );
                                // console.log("error result", result)
                                return;
                              }
                              let body = {
                                token: result.token.id,
                                amount: Number(total.toFixed(2)),
                                email: email,
                              };
                              let deliveryAdd = {
                                first_name: firstName,
                                last_name: lastName,
                                country: country,
                                town: town,
                                zipCode: zipCode,
                                address1: address1,
                                address2: address2,
                              };
                              // console.log("body", body)
                              await axios
                                .post(`${BASE_DOMAIN}/createMemoraCharge`, body)
                                .then(
                                  async (res) => {
                                    // console.log("resp", res);
                                    if (res.data.error == false) {
                                      setChargeId(res.data.charge.id);
                                      setCustomerId(res.data.customer.id);
                                      await setPayLoading(false);
                                      setPayComplete(true);
                                      dispatch(
                                        customAlert(true, "Payment Successful")
                                      );
                                      setTimeout(() => {
                                        dispatch(customAlert(false, ""));
                                      }, 1500);
                                      // toast.success(
                                      // 	'Payment Successful'
                                      // );
                                      let obj = {
                                        user: id,
                                        created_at:
                                          firebase.firestore.Timestamp.now(),
                                        delivery_address: deliveryAdd,
                                        qr_orders: qr_list,
                                        total: Number(total.toFixed(2)),
                                        status: "placed",
                                        chargeId: res.data.charge.id,
                                        customerId: res.data.customer.id,
                                      };
                                      dispatch(createOrder(obj)).then((res) => {
                                        checkOutToggle();
                                        toggleModal("confirmation");
                                      });
                                    } else {
                                      dispatch(
                                        customAlert(true, res.data.msgs)
                                      );
                                      setTimeout(() => {
                                        dispatch(customAlert(false, ""));
                                      }, 1500);
                                      // toast.warning(
                                      // 	res
                                      // 		.data
                                      // 		.msgs
                                      // );
                                      setPayLoading(false);
                                    }
                                  },
                                  (error) => {
                                    dispatch(customAlert(true, error));
                                    setTimeout(() => {
                                      dispatch(customAlert(false, ""));
                                    }, 1500);
                                    // toast.warning(
                                    // 	error
                                    // );
                                    setPayLoading(false);
                                  }
                                );
                            }
                          }}
                        >
                          <Label class="offerheading text-center mb-2">
                            <h3 class="text-center">
                              <b>Card Detail</b>
                            </h3>
                          </Label>

                          <FormGroup>
                            <Label>Card number</Label>
                            <div
                              className="form-control mt-2 d-flex"
                              style={{
                                justifyContent: "space-between",
                              }}
                            >
                              <i className="fa fa-credit-card"></i>
                              <div
                                style={{
                                  flexBasis: "90%",
                                }}
                              >
                                <CardNumberElement
                                  required
                                  options={{
                                    placeholder: "1234 1234 1234 1234",
                                    style: {
                                      base: {
                                        // backgroundColor: "#232733",
                                        fontSize: "16px",
                                      },
                                      invalid: {
                                        color: "#9e2146",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label>Expiry Date</Label>
                            <div
                              className="form-control mt-2 d-flex"
                              style={{
                                justifyContent: "space-between",
                              }}
                            >
                              <i className="fa fa-calendar"></i>
                              <div
                                style={{
                                  flexBasis: "90%",
                                }}
                              >
                                <CardExpiryElement
                                  required
                                  options={{
                                    placeholder: "MM/YY",
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                      },
                                      invalid: {
                                        color: "#9e2146",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          </FormGroup>
                          <FormGroup>
                            <Label>CVC/CVV</Label>
                            <div
                              className="form-control mt-2 d-flex"
                              style={{
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  flexBasis: "80%",
                                }}
                              >
                                <CardCvcElement
                                  required
                                  options={{
                                    placeholder: "...",
                                    style: {
                                      base: {
                                        fontSize: "16px",
                                      },
                                      invalid: {
                                        color: "#9e2146",
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </div>
                          </FormGroup>
                          <Button
                            disabled={payComplete || payLoading}
                            className="mt-3 mb-3 btn btn-outline dashboard-btn"
                            type="submit"
                          >
                            {payLoading ? <Spinner size="sm" /> : "Pay"}
                          </Button>
                          <Button
                            disabled={payLoading}
                            className="ml-3 btn-outline dashboard-btn"
                            onClick={(e) => checkOutToggle()}
                          >
                            Back
                          </Button>
                        </Form>
                      )}
                    </ElementsConsumer>
                  </Elements>
                </div>
                <div className="d-flex align-items-center">
                  <i className="fa fa-lock mr-2"></i>{" "}
                  <small>100% Secure Payment with memora</small>
                </div>
              </div>
            </Col>
            <Col xl="5">
              <div className="cart">
                <div className="modal-content-wrapper">
                  <h5 className="font-weight-bold">My Shopping Cart</h5>
                  <div className="cart-item">
                    <div className="cart-cols  f-12 text-muted">
                      <span>Product:</span>
                      <span className="text-center">Quantity</span>
                      <span className="text-center">Price</span>
                      <span className="text-center">Action</span>
                    </div>
                    {qr_list &&
                      qr_list.map((qr_cart, index) => {
                        total = total + qr_cart.price * qr_cart.qty;
                        console.log("total", total);
                        return (
                          <Cart
                            key={index}
                            dispatch={dispatch}
                            qr_cart={qr_cart}
                            qrCodesBGColors={qrCodesBGColors}
                            getMemoirName={getMemoirName}
                          />
                        );
                      })}
                    <div
                      style={{
                        borderTop: "1px solid #00000040",
                      }}
                      className="mt-4 d-flex"
                    >
                      <h4 className="ml-auto pt-2 font-weight-bold">
                        Total:{" "}
                        <span
                          style={{
                            color: "#D93D13",
                          }}
                        >
                          £{total.toFixed(2)}
                        </span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={modals.confirmation} size="lg" centered>
        <ModalBody className="p-5">
          <div className="position-relative text-center">
            <img
              src={paymentsuccess}
              onClick={(e) => toggleModal("confirmation")}
              className="mb-3"
            />
          </div>
          <div className="text-center">
            <h4 className="font-weight-bold text-uppercase">Thank You</h4>
            <h6 className="font-weight-bold text-uppercase">
              Your order is confirmed
            </h6>
          </div>
          <div className="d-flex align-items-center justify-content-center">
            <Button
              className="btn-outline mt-4 dashboard-btn"
              onClick={(e) => toggleModal("confirmation")}
            >
              homepage
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}
const Cart = (props) => {
  let { qr_cart, qrCodesBGColors, getMemoirName, dispatch } = props;
  return (
    <>
      <div className="cart-cols header pt-2">
        <span>
          <span className="d-flex align-items-center">
            <div
              className="p-1 m-0 text-center"
              style={{
                backgroundColor: qrCodesBGColors[qr_cart.template],
                width: 74,
                height: 74,
              }}
            >
              <QRCode
                value={qr_cart.qrValue}
                bgColor={qrCodesBGColors[qr_cart.template]}
                fgColor="#484E9C"
                size={64}
              />
              {/* <img
                              src={qrCode1}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            /> */}
            </div>
            <div className="ml-2 f-14">
              <small className="d-block font-weight-bold">QR Code</small>
              <small className="d-block f-12">ID: {qr_cart.qrID}</small>
              <small className="d-block font-weight-bold">
                Material: {qr_cart.material}
              </small>
            </div>
          </span>

          <small className="font-weight-bold f-12">
            {getMemoirName(qr_cart.memoirID)}
          </small>
          <br />
          <small
            style={{
              fontSize: 10,
            }}
            className="d-flex flex-column"
          >
            <span>Top Text: {qr_cart.topText}</span>
            <span>Bottom Text: {qr_cart.bottomText}</span>
            <span>Template: {qr_cart.template + 1}</span>
          </small>
        </span>
        <span className="text-center">
          <div className="counter ml-auto d-flex align-items-center">
            <button
              className="qt-control font-weight-bold border-0"
              disabled={qr_cart.qty <= 1}
              onClick={() => {
                dispatch(subQuantity(qr_cart.memoirID));
              }}
            >
              -
            </button>
            <span className="f-14 font-weight-bold">{qr_cart.qty}</span>
            <button
              className="qt-control font-weight-bold border-0"
              onClick={() => {
                dispatch(addQuantity(qr_cart.memoirID));
              }}
            >
              +
            </button>
          </div>
        </span>
        <span className="text-center">
          <small className="font-weight-bold">
            £{(qr_cart.qty * qr_cart.price).toFixed(2)}
          </small>
        </span>
        <span className="text-center">
          <small className="font-weight-bold">
            <i
              className="fa fa-trash pointer text-danger"
              onClick={() => {
                dispatch(removeFromCart(qr_cart.memoirID));
              }}
            ></i>
          </small>
        </span>
      </div>
    </>
  );
};

export default Checkout;
